import { Company } from "./company.model"
import { Poligon } from "./poligon.model"

export class Car {
    public id?: number
    public plate?: string
    public eLatitude?: string
    public eLongitude?: string
    public polygonId?: number
    public poligon?: Poligon
    public companyId?: number
    public company?:Company
    public status?:boolean
    public simulation?:boolean
    public fuelPerMinute?:number
    public fuelPerKm?:number
    public imei?:string
}